// Resize the iframe by sending messages to the parent.
import { iframeResizerContentWindow } from 'iframe-resizer';

// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Turbolinks from 'turbolinks';
// import * as ActiveStorage from '@rails/activestorage';
// import '../channels';

iframeResizerContentWindow; // eslint-disable-line no-unused-expressions

Turbolinks.start();
// ActiveStorage.start();
